import _ from 'underscore'

import Brand from 'helpers/brand'

import Api from 'services/api'
import BaseModel from 'models/BaseModel'

const defaultSiteMessage = {
  id: null,
  brands: Brand.allBrandsOfCurrentBusinessUnit(),
  roles: ['dealer', 'fsr', 'technician'],
  tiers: ['standard'],
  siteBannerEnabled: false,
  imageType: 'image',
  messageType: 'info',
  published: false,
  publishedAt: null
}

class SiteMessage extends BaseModel {
  constructor (options = defaultSiteMessage) {
    super(options || defaultSiteMessage)
    Object.seal(this)
  }

  save (updatedSiteMessageAttributes, onSaveSuccessCallback, onSaveFailCallback, onValidationErrorCallback) {
    const errors = { ...this._validate(updatedSiteMessageAttributes) }

    if (_.isEmpty(errors)) {
      const apiMethodName = updatedSiteMessageAttributes.id ? 'update' : 'create'

      return Api.SiteMessages[apiMethodName]({ ...defaultSiteMessage, ...updatedSiteMessageAttributes })
        .then((response) => {
          onSaveSuccessCallback(response)
        })
        .catch(() => {
          // NOTE: for this case, all front-end validations cover all backend validations,
          // but other models might have validations that can only be checked on the backend (like unique constraints),
          // and this implementation will not work for those cases.
          onSaveFailCallback()
        })
    } else {
      onValidationErrorCallback(errors)
    }
  }

  delete (onDeleteSuccessCallback, onDeleteFailCallback) {
    return Api.SiteMessages.delete(this.id)
      .then(() => {
        onDeleteSuccessCallback()
      })
      .catch(() => {
        onDeleteFailCallback()
      })
  }

  _validate (attributes) {
    const errors = {}

    const hasCaptionOrLink = attributes.actionButtonCaption || attributes.actionButtonLink

    const hasCaptionAndLink = attributes.actionButtonCaption && attributes.actionButtonLink

    if (_.isEmpty(attributes.brands)) {
      errors.brands = 'At least one brand is required'
    }

    if (_.isEmpty(attributes.tiers)) {
      errors.tiers = 'At least one tier is required'
    }

    if (_.isEmpty(attributes.roles)) {
      errors.roles = 'At least one role is required'
    }

    if (!attributes.title) {
      errors.title = 'Title is required'
    }

    if (!attributes.message) {
      errors.message = 'Message is required'
    }

    if (hasCaptionOrLink && !hasCaptionAndLink) {
      errors.actionButtonCaption = 'An action button cannot be added without both a caption and a link'
    }

    return errors
  }
}

export default SiteMessage
